import "../../css/sidebar.css";

import { Divider, Drawer } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Admin from "./Admin";
import Spa from "./Spa";
import { styles } from "./styles";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "",
      moduleRole: {},
    };
  }
  async componentDidMount() {
    this.props.onRef(this);
    let { pathname } = this.props.location;
    pathname = pathname.split("/");

    this.setState({ selected: pathname[1] });
  }
  handleSelected = (selected) => {
    if (this.Admin) this.Admin.handleSelect(selected);
    if (this.Spa) this.Spa.handleSelect(selected);
  };
  render() {
    const {
      classes,
      role,
      open,
      permission,
      moduleRole,
      ...props
    } = this.props;
    const { selected } = this.state;
    if (permission.loginAdmin) {
      return (
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(
              classes.drawerPaper,
              !open && classes.drawerPaperClose
            ),
          }}
          className={"sidebar"}
          open={open}
        >
          <div className={classes.toolbarIcon}></div>
          <Divider />
          {(role === "employeeSpa" || role === "ownerSpa") && (
            <Spa
              open={open}
              selected={selected}
              moduleRole={moduleRole}
              {...props}
              onRef={(id) => (this.Spa = id)}
            />
          )}
          {(role === "employeeAdmin" || role === "admin") && (
            <Admin
              open={open}
              selected={selected}
              moduleRole={moduleRole}
              {...props}
              onRef={(id) => (this.Admin = id)}
            />
          )}
        </Drawer>
      );
    } else return "";
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  role: state.user.user.roleId.role,
  permission: state.user.user.roleId,
  moduleRole: state.user.module,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Sidebar)));
